/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const Section = styled.div`
  max-width: 1440px;
  margin: 0 auto;

  padding: 2rem 1rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-direction: column;
  @media (min-width: 767px) {
    padding: 4rem 3rem;
    flex-direction: row;
    gap: 4rem;
  }
  @media (min-width: 1024px) {
    padding: 6rem 5rem;
  }
`;

export const CTATitle = styled.h2`
  font-weight: 600;
  font-size: 36px;
  line-height: 114.99%;
  letter-spacing: -2px;
  color: ${COLORS.BLACK};
  @media (min-width: 767px) {
    font-size: 50px;
  }
`;

export const CTAButtons = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 1rem;
  margin: auto 0;
  justify-content: center;
  .gradient-orange-btn {
    color: #ffffff;
    width: auto;
    height: 54px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.24); /* #FFFFFF3D */
    padding: 6px 12px;
    font-weight: 400;
    background:
      linear-gradient(180deg, #FF7A3C 0%, #FF662A 100%),
      radial-gradient(100% 100% at 50% 0%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 8px -2px rgba(210, 71, 72, 0.22);
    transition: all 0.3s ease;
  }
  .orange-outline-btn {
    background-color: transparent;
    color: #FF733C;
    width: auto;
    height: 54px;
    border-radius: 8px;
    border: 1px solid #FF662A;
    padding: 6px 12px;
    font-weight: 400;
    transition: all 0.3s ease;
  }
  .orange-outline-btn:hover {
    background-color: #FF662A;
    color: #FFFFFF;
  }
  
  @media (min-width: 768px) {
    .gradient-orange-btn {
      width: 185px;
      height: 54px;
    }
    .orange-outline-btn {
      width: 185px;
      height: 54px;
    }
  }
  @media (min-width: 1024px) {
    flex-direction: row;
  }

`;
